import { useParams } from "react-router-dom";
// import Seo from "../seo/Seo";
import BlogRecommended from "./BlogRecommended";
import "./blog-detail.css";
import { blogs } from "../data/blogs.data";

export default function BlogDetail() {
  const { slug } = useParams();
  const blog = blogs.find((b) => b.slug === slug);

  if (!blog) return <p>Blog not found</p>;

  return (
    <>
      {/* <Seo
        title={`${blog.title} | Oglitz Blog`}
        description={blog.excerpt}
        path={`/blogs/${blog.slug}`}
      /> */}

      <article className="oglitz-blog-detail">
        <h1>{blog.title}</h1>

        <div className="oglitz-blog-detail__meta">
          <span>{blog.author}</span>
          <span>{blog.date}</span>
          <span>{blog.readingTime}</span>
        </div>

        <div
          className="oglitz-blog-detail__content"
          dangerouslySetInnerHTML={{ __html: blog.content }}
        />

        <div className="oglitz-blog-detail__tags">
          {blog.tags.map((tag) => (
            <span key={tag}>{tag}</span>
          ))}
        </div>
      </article>

      <BlogRecommended currentSlug={slug} />
    </>
  );
}
